import _ from "underscore";
import EmailCheckUserNodeRenderer from "../EmailCheckUserNodeRenderer";

export default function AccessRightUserNodeRenderer( tree, selectorFilter, selectionHelper, checkEmail, messageParams, accessRight )
{
    EmailCheckUserNodeRenderer.call(this, tree, selectorFilter, selectionHelper, checkEmail, messageParams);
    this.accessRight = accessRight;
}

AccessRightUserNodeRenderer.prototype = _.create(EmailCheckUserNodeRenderer.prototype);

AccessRightUserNodeRenderer.prototype.isInvalidUser = function(user)
{
    return EmailCheckUserNodeRenderer.prototype.isInvalidUser.call(this, user) || !this.accessRight.isGranted(user.accessRight);
};

AccessRightUserNodeRenderer.prototype.getAdditionalTitle = function(user)
{
    if (!this.accessRight.isGranted(user.accessRight))
    {
        return this.messageParams.getAccessRightMessage(user);
    }
    else
    {
        return null;
    }
};



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/userSelector/accessRight/AccessRightUserNodeRenderer.js